Alpine.store("raw_material_purchase", {
    products: [],
    blink: null,
    register_at: null,
    contact: null,
    received: undefined,

    reset() {
        this.products = [];
        this.blink = null;
        this.register_at = null;
        this.contact = null;
        this.storage?.persist();
        this.received = undefined;
    },

    formData() {
        return {
            products: this.products,
            contact: this.contact,
            register_at: this.register_at,
            received: this.getReceived(),
        };
    },

    setReceived(evt) {
        this.received = rwsp(evt.target.value);
    },

    getReceived() {
        if (this.received !== undefined) return this.received;
        return this.net;
    },

    isEmpty() {
        return !!this.products?.length;
    },

    get storage() {
        if (!localStorage) return null;

        let store = this;
        return {
            persist() {
                const data = {
                    products: store.products,
                    contact: store.contact,
                    register_at: store.register_at,
                };
                localStorage.setItem(
                    "raw_material_purchase_data",
                    JSON.stringify(data),
                );
            },
            data() {
                return JSON.parse(
                    localStorage.getItem("raw_material_purchase_data") || "{}",
                );
            },
            restore(data) {
                if (!data) data = this.data();
                store.products = data.products || [];
                store.contact = data.contact;
                store.register_at = data.register_at;
            },
            reset() {
                localStorage.removeItem("raw_material_purchase_data");
            },
        };
    },

    prod: function (prod) {
        const store = this;
        return {
            get add() {
                let old = store.products.find((p) => p.id == prod.id);
                if (old) old.qte = (old.qte || 1) + 1;
                else {
                    store.products.unshift({
                        id: prod.id,
                        qte: 1,
                        price: prod.last_purchase_price,
                        discount: null,
                        original: prod,
                    });
                }
                store.storage?.persist();
                this.blink();
            },

            get remove() {
                store.products.splice(store.products.indexOf(prod), 1);
                store.storage?.persist();
                return prod;
            },

            blink() {
                store.blink = prod.id;
                setTimeout(() => (store.blink = undefined), 500);
            },

            get ttc() {
                return prod.price * prod.qte;
            },
        };
    },

    prods: function () {
        let store = this;
        return {
            get ttc() {
                let a = 0;
                store.products.forEach((p) => (a += store.prod(p).ttc));
                return a;
            },
        };
    },

    get net() {
        return this.prods().ttc;
    },
});

Alpine.data("raw_material_purchase", function (initial = {}) {
    return {
        init() {
            const store = this.$store.raw_material_purchase;
            store.register_at = initial.register_at;

            const old = store.storage?.data();
            store.storage?.restore();
        },

        purchase_reset() {
            this.$store.raw_material_purchase.reset();
            this.$store.raw_material_purchase.storage.reset();
        },

        purchase_submit() {
            const store = this.$store.raw_material_purchase;
            this.$wire.call("save_purchase", store.formData());
        },
    };
});
